import { styles as styleHelpers } from '../../../../assets/style-helpers.scss';
import { styles } from './template.scss';
import { LabelWidthValues } from '../../../../types/common/types';

export const templateSchemaHelper = document.createElement('template');

templateSchemaHelper.innerHTML = `
  <style>${styleHelpers}</style>
  <style>${styles}</style>

  <div class="wrapper">
    <div class="title-header"></div>
    <gz-input-search id="schema-helper-input-search" type="text" maxlength="100"></gz-input-search>
    <gz-enum-filter id="schema-helper-os-filter" labelWidth="${LabelWidthValues.XLARGE}"></gz-enum-filter>
    <div class="tables-header"></div>
    <div id="schema-helper-accordions"></div>
  </div>
`;

templateSchemaHelper.style.height = '100%';
